import { IShipment } from 'src/shared/contract/shipment'
import { Array } from 'runtypes'
import { fetchApi } from 'src/shared/lib/response-worker/model'
import { IPrescriptionCatalogGoods, PrescriptionCatalogGoods } from 'src/pages/prescription/contract'
import { webApiBuildUrl } from '@api/utils'

export const prescriptionUrl = () => webApiBuildUrl(`api/prescription/GetPrescriptionsCatalogGoods`)

export const prescriptionGoodsApi = async (prescriptionGuids: string[], shipment: IShipment) => {
    const response = await fetchApi.post<IPrescriptionCatalogGoods[]>(prescriptionUrl(), {
        prescriptionGuids,
        shipment
    })
    return response.data
}
